import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { Route, Routes } from '@angular/router';
import { FormatoArquivo } from '@core/enums/formato-arquivo.enum';
import { TipoPerfil } from '@core/enums/perfil.enum';
import { ArquivoService } from '@core/services/arquivo.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { ErrorMessage } from 'src/app/core/models/error-message.model';
import { environment } from 'src/environments/environment';
import { FilterStateService } from '../services/filter-state.service';
import { EnumBaseType } from '../types/enum-base.type';

const NAME_PROJECT  = environment.namespaceProject;

export class Util {
  /**
   * Função para setar os errors da requisição conforme de acordo com os seus tipos
   * @param errorMessage Objeto utilizado para incluir os erros
   * @param error Objeto que vem o HttpErroResponse
   * @param typeErr String para setar qual o tipo de error ex: danger, success, warning, info
   * @param errorCustom Boolean para caso queira inserir uma mensagem sem ser pelo tipo do erro da requisição
   */
  static setErrorMessage(
    errorMessage: ErrorMessage,
    error,
    typeErr = 'danger',
    errorCustom = false
  ) {
    if (errorCustom) {
      errorMessage.errorType = typeErr;
      errorMessage.existError = true;
      errorMessage.errorList = this.setErrorList(error);
    }

    if (!errorCustom && error.status === 400) {
      errorMessage.errorType = typeErr;
      errorMessage.existError = true;
      errorMessage.errorList = this.setErrorList(error);
    }

    if (!errorCustom && error.status === 403) {
      errorMessage.errorType = 'warning';
      errorMessage.existError = true;
      errorMessage.errorList.push('Usuário não tem permissão de acesso!');
    }

    if ((!errorCustom && error.status === 0) || error.status === 404) {
      errorMessage.errorType = 'warning';
      errorMessage.existError = true;
      errorMessage.errorList.push(
        'Oopss ocorreu um erro ao processar o seu pedido, não conseguimos conectar com os nossos serviços, por favor tente novamente!'
      );
    }

    setTimeout(() => {
      this.clearErrorMessage(errorMessage);
    }, 10000);
  }

  static setErrorMessageCustom(
    errorMessage: ErrorMessage,
    error: any,
    typeErr = 'danger',
    timeoutClearMessage = 30000
  ) {
    errorMessage.errorType = typeErr;
    errorMessage.existError = true;
    errorMessage.errorList = this.setErrorListCustom(error);

    setTimeout(() => {
      this.clearErrorMessage(errorMessage);
    }, timeoutClearMessage);
  }

  /**
   * Função para Limpar Objeto utilizado para incluir os erros
   * @param errorMessage Objeto utilizado para incluir os erros
   */
  static clearErrorMessage(errorMessage: ErrorMessage) {
    errorMessage.errorType = '';
    errorMessage.existError = false;
    errorMessage.errorList = [];
  }

  /**
   * Função utilizada para setar os errors na lista de acordo com a requisição
   * @param error Objeto que vem o HttpErroResponse
   */
  static setErrorList(error) {
    let list = [];
    Array.isArray(error.error.errors)
      ? (list = error.error.errors)
      : list.push(error.error.errors);
    return list;
  }

  /**
   * Função utilizada para setar os errors na lista custumizada de acordo com a requisição
   * @param error Objeto que vem o HttpErroResponse
   */
  static setErrorListCustom(error) {
    let list = [];
    Array.isArray(error) ? (list = error) : list.push(error);
    return list;
  }

  /**
   * Função para alterar o valor do botão de Buscar
   * @param buttonSubmitConfig Objeto para configuração do botão
   * @param isResp Controle a submissão do botão
   */
  static setBtnFilterReq(buttonSubmitConfig?, isResp = false) {
    if (buttonSubmitConfig) {
      buttonSubmitConfig.buttonText = !isResp ? 'Buscando' : 'Buscar';
      buttonSubmitConfig.buttonSubmited = !isResp;
    }
  }

  /**
   * Função para alterar o valor do botão de Submissão
   * @param buttonSubmitConfig Objeto para configuração do submissão
   * * @param isResp Controle a submissão do botão
   */
  static setBtnSubmitReq(buttonSubmitConfig?, isResp = false) {
    if (buttonSubmitConfig) {
      buttonSubmitConfig.buttonText = !isResp ? 'Salvando' : 'Salvar';
      buttonSubmitConfig.buttonSubmited = !isResp;
    }
  }

  /**
   * Função para alterar o valor do botão de Submissão
   * @param buttonSubmitConfig Objeto para configuração do submissão
   * * @param isResp Controle a submissão do botão
   */
  static setBtnSubmitReqCustom(
    buttonSubmitConfig?,
    isResp = false,
    desc1 = '',
    desc2 = ''
  ) {
    if (buttonSubmitConfig) {
      buttonSubmitConfig.buttonText = !isResp ? desc2 : desc1;
      buttonSubmitConfig.buttonSubmited = !isResp;
    }
  }
  /**
   * Metodo para pegar o nome para a tela (cadastrar/editar)
   * @param id Identificador
   * @param detalhes Bolean para informar se a tela é de detalhes
   */
  static getScreenName(id?: string, detalhes = false) {
    return !id || !id.trim()
      ? 'ADICIONAR'
      : id && !detalhes
      ? 'EDITAR'
      : 'VISUALIZAR';
  }

  /**
   * Função para setar a classe de errro no campo
   * @param formGroup FormGroup do parametro
   * @param messageDisplay Mensagem a ser exibida
   * @param field Campo que receberá a mensagem de validação
   */
  static setErrorsValidate(
    formGroup: FormGroup,
    messageDisplay,
    field: string
  ) {
    if (messageDisplay[field]) {
      return 'is-invalid';
    }
  }

  /**
   * Função para preencher os valores pelo ID
   * @param resp variavel que vem os dados da requisição
   * @param formGroup variavel que traz o form group
   */
  static patchValueForm(obj: any, formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((key) => {
      if (obj[key]) {
        formGroup.controls[key].patchValue(obj[key]);
      }
    });
  }

  /**
   * Adiciona na URL o parametro de "Ativo" com o valor "true"
   */
  static createFilterStatusActive() {
    const params: URLSearchParams = new URLSearchParams();
    params.append('ativo', 'true');

    return params;
  }

  /**
   * Retorna as URL Search Params utilizadas nas requisições
   */
  static createFilter() {
    const params: URLSearchParams = new URLSearchParams();
    return params;
  }

  /**
   * Remove os acentos da string
   * @param str string para ser removida os acentos
   */
  static removeAccents(str) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  /**
   * Limpa todos os campo do form
   * @param formGroup O form a ser limpo os campos
   */
  static clearFields(formGroup: FormGroup | FormArray) {
    Object.keys(formGroup.controls).forEach((campo) => {
      const control = formGroup.get(campo);
      if (control instanceof FormGroup || control instanceof FormControl) {
        if (control instanceof FormGroup) {
          this.clearFields(control);
        } else {
          if (Array.isArray(control.value)) {
            control.setValue([]);
          } else {
            control.setValue('');
          }
        }
      } else if (control instanceof FormArray) {
        control.controls.splice(0);
        control.updateValueAndValidity();
      }
    });
    formGroup.updateValueAndValidity();
  }

  /**
   * Cria as query params do filtro de busca
   * @param param Objero a ser convertido em parametros
   */
  static getQueryParams(param: object) {
    const params: URLSearchParams = Util.createFilter();

    Object.keys(param).forEach((campo) => {
      const item = param[campo];
      if (item) {
        params.append(campo, item);
      }
    });

    return params;
  }

  /**
   * Obtem os campos invalidos do form
   * @param form Form a ser verificado
   */
  static catchFieldsInvalids(form: FormGroup | FormArray): string[] {
    const invalidControls: string[] = [];

    const recursiveFunc = (formGP: FormGroup | FormArray) => {
      Object.keys(formGP.controls).forEach((field) => {
        const control = formGP.get(field);
        if (control instanceof FormGroup) {
          recursiveFunc(control);
        } else if (control instanceof FormArray) {
          recursiveFunc(control);
        } else {
          if (control.invalid) {
            invalidControls.push(field);
          }
        }
      });
    };
    recursiveFunc(form);
    return invalidControls;
  }

  /**
   * * Abre o modal no tamanho
   * @param modalService Serviço do modal
   * @param component O componente a ser aberto
   * @param size O tamanho do modal (lg, xl, sm) / Valor defaul md
   */
  static openModal(
    modalService: NgbModal,
    component: any,
    size: string = 'md'
  ) {
    const modalRef = modalService.open(component, {
      backdrop: 'static',
      size,
      keyboard: false,
      windowClass: 'modal-custom-' + size,
    });

    return modalRef;
  }

  /**
   * Convert o arquivo de base64 em BlobData
   * @param base64Data Arquivo em Base64
   * @param contentType Tipo do content type
   * @param sliceSize Tamanhp do arquivo
   */
  static convertBase64ToBlobData(
    base64Data: string,
    contentType: string = 'image/png',
    sliceSize = 512
  ) {
    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  }

  static distinct(myArr, prop): any[] {
    return myArr.filter((obj, pos, arr) => {
      return arr.map((mapObj) => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
  }

  static getUsuarioSession() {
    const usuLocal = localStorage.getItem(`${NAME_PROJECT}.usuario`);
    return usuLocal ? JSON.parse(atob(usuLocal)) : null;
  }

  static isUserAdmin(): boolean {
    const usuario = this.getUsuarioSession();

    return usuario.nome?.toUpperCase() === TipoPerfil.ADM;
  }

  static isUserSeect(): boolean {
    const usuario = this.getUsuarioSession();

    return usuario.nome?.toUpperCase() === TipoPerfil.SEECT;
  }

  static isUserProfessor(): boolean {
    const usuario = this.getUsuarioSession();

    return usuario.nome?.toUpperCase() === TipoPerfil.PROFESSOR;
  }

  static getperfilDescriptionSession() {
    const usuLocal = localStorage.getItem(`${NAME_PROJECT}.perfil`);
    return usuLocal ? JSON.parse(atob(usuLocal)) : null;
  }

  static getListYear(): any[] {
    const yearToday = new Date().getFullYear();
    const range = [];
    range.push(yearToday);
    for (let i = 1; i < 12; i++) {
      range.push(yearToday - i);
    }
    return range;
  }

  static getRandomColor() {
    const color = Math.floor(0x1000000 * Math.random()).toString(16);
    return '#' + ('000000' + color).slice(-6);
  }
  // 2022-03-16T17:39:34.185889
  static formatDateHours(date?: string): string {
    if (date) {
      const ano = date.substring(0, 4);
      const mes = date.substring(5, 7);
      const dia = date.substring(8, 10);

      const newDate = new Date(date);

      const horas = newDate.getHours();
      const minutos = newDate.getMinutes();

      return dia + '/' + mes + '/' + ano  + ' às ' + Util.formatNumberDate(horas) + ':' + Util.formatNumberDate(minutos);
    }
  }

  static formatDate(date?: string): string {
    if (date) {
      const ano = date.substring(0, 4);
      const mes = date.substring(5, 7);
      const dia = date.substring(8, 10);

      return dia + '/' + mes + '/' + ano;
    }
  }

  static formatNumberDate(numberDate: number){
    return numberDate < 10 ? ('0' + numberDate) : numberDate;
  }


  /**
   * Função que retorna um string com o formato 'YYYY-MM-DD'
   * @param date data a ser convertida para o formato do form
   */

  static formatDateToInputFormat(date: string) {
    return moment(date).format('YYYY-MM-DD');
  }

  /**
   * Função que converte uma string com o formato 'YYYY-MM-DD' em uma data
   * @param date data em string a ser convertida para o formato de data
   */

  static formatStringToDate(date: string) {
    return date && new Date(
      Number(date.slice(0, 4)),
      Number(date.slice(5, 7)) - 1,
      Number(date.slice(8, 10))
    );
  }

  /**
   * Função que converte uma string com o formato 'DD-MM-YYYY' em "yyyy-MM-dd HH:mm:ss"
   * @param date data em string a ser convertida para o formato de data e horas
   */
  static formatDateHoursParaDataPicker(date: string) {
    const partesData = date.split('/');
    const dataFormatada = new Date(+partesData[2], +partesData[1] - 1, +partesData[0]);
    return dataFormatada.toISOString().split('T')[0] + " 00:00:00";
  }


  static getAnos(): Array<any> {
    const anosList = [];

    for (let ano = 2012; ano <= 2012 + 11; ano++) {
      anosList.push({
        name: ano,
        value: ano,
      });
    }

    return anosList;
  }

  static getHorarios(): Array<any> {
    const horariosList = [];

    for (let hora = 0; hora < 24; hora++) {
      for (let minutos = 0; minutos < 56; minutos += 5) {
        const data = moment();
        data.hour(hora);
        data.minute(minutos);

        horariosList.push({
          name: data.format('HH:mm'),
          value: data.format('HH:mm'),
        });
      }
    }
    return horariosList;
  }

  static getDadosAlocacao(): any {
    const dadosHash = localStorage.getItem(`dadosAlocacao`);
    if (dadosHash){
      return JSON.parse(atob(dadosHash));
    }

    return '';
  }

  static getDadosProfissional(): any {
    const dadosHash = localStorage.getItem(`${NAME_PROJECT}.dadosMatriculaProfissional`);
    if (dadosHash){
      return JSON.parse(atob(dadosHash));
    }

    return '';
  }

  static getDadosPessoais(): any {
    const dadosHash = localStorage.getItem(`${NAME_PROJECT}.dadosPessoaisProfessor`);
    if (dadosHash){
      return JSON.parse(atob(dadosHash));
    }

    return '';
  }

  static getAnoLetivo(): any {
    const dadosHash = localStorage.getItem(`${NAME_PROJECT}.anoLetivoId`);
    if (dadosHash){
      return JSON.parse(atob(dadosHash));
    }

    return '';
  }

  static getMatricula(): any {
    const dadosHash = localStorage.getItem(`${NAME_PROJECT}.matriculaId`);
    if (dadosHash){
      return JSON.parse(atob(dadosHash));
    }

    return '';
  }


  static validateAllFormFields(formGroup: any, ignoreControls: string[] = []) {
    Object.keys(formGroup.controls).forEach(field => {
        const control = formGroup.get(field);
        if (ignoreControls.includes(field)) {
          return;
        }

        if (control instanceof FormControl) {
          control.markAsTouched({ onlySelf: true });
        } else if (control instanceof FormGroup) {
          this.validateAllFormFields(control);
        } else if (control instanceof FormArray) {
          this.validateAllFormFields(control);
        }
    });

    return formGroup.valid;
  }
   /**
   * Retorna um array de intervalo de horas, de 5 em 5 min.
   * Recebe como parametro uma string da data hora inicial e a data hora final, ex: 2022-10-17T00:00:00.
   */
   static intervalosHoras5min(dataHoraInicio: string, dataHoraFim: string): Array<any> {
    const intervalos: Array<any> = [];
    let intervaloAtual: any;

    const dataInicioFormatada = moment(dataHoraInicio);
    const dataFimFormatada = moment(dataHoraFim);
    //Adiciona 24h caso as datas horas, sejam iguais, para poder pegar os intervalos
    if(dataInicioFormatada.toLocaleString() === dataFimFormatada.toLocaleString()){
      dataFimFormatada.add(24, 'hours');
    }
    //Adiciona 5 min a data fim, para na hora de adicionar ao array, incluir o ultimo horario.
    else{
      dataFimFormatada.add(5, 'm');
    }

    while(dataInicioFormatada < dataFimFormatada){

      intervaloAtual = {
        name: dataInicioFormatada.format('HH:mm'),
        value: dataInicioFormatada.format('HH:mm')
      }

      intervalos.push(intervaloAtual);


      dataInicioFormatada.add(5, 'm');
    }
    return intervalos;
  }

  static sortRoutes(rotas: Routes) {
    return rotas.sort((a: Route, b: Route) => {
      if (a.path > b.path) {
        return 1;
      } else if (a.path < b.path) {
        return -1;
      } else {
        return 0;
      }
    });
  }

  static sortList(list: any[], attr = 'name') {
    return list.sort((a: Route, b: Route) => {
      if (a?.[attr] > b?.[attr]) {
        return 1;
      } else if (a?.[attr] < b?.[attr]) {
        return -1;
      } else {
        return 0;
      }
    });
  }

  static getCurrentMatriculaId() {
    const matriculaId = localStorage.getItem(`${NAME_PROJECT}.matriculaId`);
    return matriculaId ? JSON.parse(atob(matriculaId)) : null;
  }

  static getCurrentAnoLetivoId() {
    const anoLetivoId = localStorage.getItem(`${NAME_PROJECT}.anoLetivoId`);
    return anoLetivoId ? JSON.parse(atob(anoLetivoId)) : null;
  }

  static getCurrentMatriculaNomeEscola() {
    const matriculaNomeEscola = localStorage.getItem(`${NAME_PROJECT}.matriculaNomeEscola`);
    if(!matriculaNomeEscola){
      return null;
    }
    const [matricula, nomeEscola] = JSON.parse(atob(matriculaNomeEscola)).matricula.split("|");
    return {matricula, nomeEscola}
  }

  static alertaAlterarFrequenciasDosEstudantes() {
    const errors: ErrorMessage = new ErrorMessage();

    errors.errorType = 'danger';
    errors.existError = true;
    errors.errorList = [ `Não é possível realizar alterações nos campos, pois há registro de avaliação relacionado a este registro. Portanto, só será possível alterar as frequências dos estudantes.`];

    return errors
  }
  /**
   * Função que formata o nome do mes para abreviação dele. Exemplo: "Janeiro" para "Jan"
   * @param nomeCompletoMes nome do mês para abreviar
   */
  static abreviarNomeMes(nomeCompletoMes: string): string {
    return nomeCompletoMes.slice(0, 3);
  }

  static convertEnumToArray(enumType): EnumBaseType[] {
    return Object.entries(enumType).map(
      ([value, name]: [string, string]) => ({
        name,
        value,
      })
    );
  }

  static getMatriculaProfessor(): any {
    const dadosHash = localStorage.getItem(`${NAME_PROJECT}.matriculaProfessor`);
    if (dadosHash){
      return dadosHash;
    }

    return '';
  }

  static getBrasilLocales(): any {
    return {
      firstDayOfWeek: 0,
      dayNames: [
        'Domingo',
        'Segunda',
        'Terça',
        'Quarta',
        'Quinta',
        'Sexta',
        'Sábado',
      ],
      dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
      dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
      monthNames: [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro',
      ],
      monthNamesShort: [
        'Jan',
        'Fev',
        'Mar',
        'Abr',
        'Mai',
        'Jun',
        'Jul',
        'Ago',
        'Set',
        'Out',
        'Nov',
        'Dez',
      ],
      today: 'Hoje',
      clear: 'Limpar',
      weekHeader: 'Semana',
    };
  }

  static patchSavedFilter(filterStateService: FilterStateService, crudKey: string, form: FormGroup, ignoreControls?: string[]): void {
    const savedFilters = filterStateService.getFilter(crudKey);
    if (savedFilters) {
      Object.keys(form.controls).forEach((key) => {
        if (!ignoreControls?.includes(key)) {
          if (savedFilters[key] !== undefined) {
            form.get(key).patchValue(savedFilters[key]);
          }
        }
      });
    }
  }

  static replaceLast(value: string, seachValue: string, replaceValue: string): string {
    const index = value.lastIndexOf(seachValue);
    if (index === -1) {
      return value;
    }
    return value.slice(0, index) + replaceValue + value.slice(index + seachValue.length);
  }

  static replacePlaceholders(template: string, values: string[]): string {
    return template.replace(/\[\d+\]/g, (placeholder) => {
      const newValue =  values[0] ?? placeholder;
      values = values.slice(1);
      return newValue;
    });
  }

  static orderList(list: any[], columnName: string, order: boolean): { list: any[], order: boolean, sortOrder: 'asc' | 'desc' } {
    list.sort((a, b) => {
      let valueA = a[columnName];
      let valueB = b[columnName];
      if (typeof valueA === 'string') {
        valueA = valueA?.toString().trim().toLowerCase();
        valueB = valueB?.toString().trim().toLowerCase();
      }
      if (order) {
        return valueA > valueB ? 1 : -1;
      } else {
        return valueA < valueB ? 1 : -1;
      }
    });

    const sortOrder = order ? 'asc' : 'desc';
    return {
      list, order, sortOrder
    };
  }

  static equalDayMonthYear(date1: Date, date2: Date) {
    return date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate();
  }

  static ordenarEventos(eventos: any[]) {
    return eventos?.sort((a, b) => {
      if (a.nome === 'Dia Letivo') {
        return 1;
      }
      if (b.nome === 'Dia Letivo') {
        return -1;
      }
      return 0;
    });
  }

  /**
   * Formata email e o nome, se não tiver nenhum registro exibe hífen,
   * se tiver apenas um, exibe apenas ele
   * se tiver dois, exibe os nomes/emails separados por 'e', exemplo: joão e maria
   * se tiver mais que dois, exibe separado por vírgula e no final 'e', exemplo: joão, maria e junior
   * @param dado a ser formatado
   * @returns dado formatado
   */
  static formatarEmailENome(dado: any[]) {
    if (!Array.isArray(dado) || !dado.some(element => element && element.trim() !== '')) {
      return '-';
    }
    const dados = dado.filter(element => typeof element === 'string' && element.trim() !== '');

    if (dados.length === 0) {
      return '-';
    }

    if (dados.length === 1) {
      return dados[0];
    }

    if (dados.length === 2) {
      return dados.join(' e ');
    }

    const ultimoElemento = dados.pop();
    return `${dados.join(', ')} e ${ultimoElemento}`;
  }

  /**
   * Convert o arquivo de base64 em BlobData (funciona para os formatos pdf, jpg, jpg e png)
   * @param base64 Arquivo em Base64
   * @param extensao Formato do arquivo
   */
  static base64toBlob(base64: string, extensao: string): Blob {
    let type = '';
    switch (extensao.toLowerCase()) {
      case FormatoArquivo.PDF:
        type = 'application/pdf';
        break;
      case FormatoArquivo.JPG:
        type = 'image/jpg';
        break;
      case FormatoArquivo.JPEG:
        type = 'image/jpeg';
        break;
      case FormatoArquivo.PNG:
        type = 'image/png';
        break;
    }
    const byteCharacters = atob(base64);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type });
  }

  static baixarArquivoPeloId(arquivo:any, arquivoService: ArquivoService) {
    const id = arquivo.arquivoId ?? arquivo.id;
    arquivoService.download(id).subscribe({
      next: (responseArquivo:any) => {
        const blob = new Blob([responseArquivo.body], { type: `application/${arquivo.extensao}` });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${arquivo.nomeOriginal ?? arquivo.nome}.${arquivo.extensao}`;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    });
  }

  static baixarArquivoComBase64(arquivo: any) {
    const blobFile = this.base64toBlob(arquivo.base64, arquivo.extensao);
    const url = window.URL.createObjectURL(blobFile);
    const tagAnchor = document.createElement('a');
    tagAnchor.href = url;
    tagAnchor.download = `${arquivo.nome}.${arquivo.extensao}`;
    tagAnchor.click();
    window.URL.revokeObjectURL(url);
  }

  static corrigirTextoParaJson(texto: string): string {
    return texto ? texto
    // Corrige valores faltando
    .replace(/:(?=,|\})/g, ':""')
    // Adiciona aspas nas chaves
    .replace(/([{,])(\w+):/g, '$1"$2":')
    // Corrige strings sem aspas (mas ignora booleans, null, numbers)
    .replace(/:([^",\{\[\]\}]+)([,\}])/g, (match, p1, p2) => {
      const trimmed = p1.trim();
      const isBooleanOrNull = ['true', 'false', 'null'].includes(trimmed);
      const isNumber = /^-?\d+(\.\d+)?$/.test(trimmed);
      return isBooleanOrNull || isNumber ? `:${trimmed}${p2}` : `:"${trimmed}"${p2}`;
    }) : '';
  }

}
